import React from 'react';
import { momentFromNow } from 'services/moment.service';
import { BagelConversationSummary } from '../../../types';
import styles from './BagelChatWidget.module.scss';

interface BagelConversationHistoryProps {
  conversations: BagelConversationSummary[];
  activeWorkflowId: string | null;
  isLoading: boolean;
  onSelect: (workflowId: string) => void;
  onNewConversation: () => void;
  onClose: () => void;
}

export default function BagelConversationHistory({
  conversations,
  activeWorkflowId,
  isLoading,
  onSelect,
  onNewConversation,
  onClose,
}: BagelConversationHistoryProps) {
  return (
    <div className={styles.historyPanel}>
      <div className={styles.historyHeader}>
        <span className={styles.historyTitle}>Conversations</span>
        <button
          type="button"
          className={styles.historyCloseBtn}
          onClick={onClose}
          aria-label="Close conversation history"
        >
          ✕
        </button>
      </div>

      <button
        type="button"
        className={styles.historyNewBtn}
        onClick={onNewConversation}
      >
        + New conversation
      </button>

      <div className={styles.historyList}>
        {isLoading && conversations.length === 0 && (
          <p className={styles.historyEmpty}>Loading…</p>
        )}
        {!isLoading && conversations.length === 0 && (
          <p className={styles.historyEmpty}>No past conversations yet.</p>
        )}
        {conversations.map(conversation => {
          const isActive = conversation.workflowId === activeWorkflowId;
          return (
            <button
              key={conversation.workflowId}
              type="button"
              className={`${styles.historyItem} ${
                isActive ? styles.historyItemActive : ''
              }`}
              onClick={() => onSelect(conversation.workflowId)}
            >
              <span className={styles.historyItemPreview}>
                {conversation.preview}
              </span>
              <span className={styles.historyItemMeta}>
                {momentFromNow(new Date(conversation.updatedOn))}
                {conversation.messageCount > 0
                  ? ` · ${conversation.messageCount} message${
                      conversation.messageCount === 1 ? '' : 's'
                    }`
                  : ''}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
